import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function postAfterSalesExtra(data) {
  return getAPIResponse('/v1/after-sales-extras', data, 'POST');
}